import Callbacks from "./callbacks.js";
import EventContext from "./event-context.js";

class EventCallbacks extends Callbacks {
    constructor(evtCtx) {
        super();

        this._evtCtx = evtCtx;
    }

    set(object, key, oldValue, newValue) {
        const events = this._evtCtx.getEvents(object, false);

        if (events) {
            events.fire("set", key, object, key, oldValue, newValue);
        }
    }

    delete(object, key, oldValue) {
        const events = this._evtCtx.getEvents(object, false);

        if (events) {
            events.fire("delete", key, object, key, oldValue);
        }
    }
}

export default EventCallbacks;
